// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__uKyQ+","content":"Table_content__9xD6t","header":"Table_header__qT5lZ","active":"Table_active__uQ95v","body":"Table_body__Fhldd"};